import * as yup from "yup";
import {stringRequired} from "../../../../../yup/defaultValudations";

export const schema = yup.object().shape({
  name: stringRequired(),
  description: stringRequired(),
  score: stringRequired(),
});
